async function loadWholesaleDiscount() {
  console.log('isWholesaleCustomer:', window.isWholesaleCustomer);

  if (!window.isWholesaleCustomer) {
    console.log('Not a wholesale customer, stopping');
    return;
  }

  try {
    const res = await fetch('https://discountringline.vercel.app/api/discount');
    console.log('discount fetch status:', res.status);

    if (!res.ok) {
      console.log('Discount fetch failed');
      return;
    }

    const discount = await res.json();
    console.log('discount response:', discount);

    if (!discount.active) {
      console.log('Discount not active');
      return;
    }

    function parseMoneyToCents(text) {
      const cleaned = String(text).replace(/[^0-9.]/g, '');
      const value = Number(cleaned);
      if (Number.isNaN(value)) return null;
      return Math.round(value * 100);
    }

    function formatCents(cents) {
      return `$${(cents / 100).toFixed(2)}`;
    }

    function updateElement(el) {
      if (!el) return;
      if (el.dataset.wholesaleApplied === 'true') return;

      const text = el.textContent.trim();
      const originalCents = parseMoneyToCents(text);

      console.log('checking element:', el, 'text:', text, 'cents:', originalCents);

      if (originalCents == null) return;

      let discountedCents = originalCents;

      if (discount.type === 'fixed' && discount.value_cents) {
        discountedCents = Math.max(0, originalCents - discount.value_cents);
      } else if (discount.type === 'percentage' && discount.percentage != null) {
        discountedCents = Math.max(
          0,
          Math.round(originalCents * (1 - discount.percentage / 100))
        );
      } else {
        console.log('Unsupported discount type');
        return;
      }

      el.innerHTML = `<s>${formatCents(originalCents)}</s> <span>${formatCents(discountedCents)}</span>`;
      el.dataset.wholesaleApplied = 'true';

      console.log('updated element:', el);
    }

    const selectors = [
      '.product-card__price span',
      '.price-item.price-item--regular',
      '[data-pf-type="ProductPrice2Item"][data-product-type="price"]'
    ];

    selectors.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      console.log(`selector ${selector}:`, elements.length);
      elements.forEach(updateElement);
    });

  } catch (error) {
    console.error('Wholesale discount load failed:', error);
  }
}

document.addEventListener('DOMContentLoaded', loadWholesaleDiscount);